<template>
    <span :class="wrapClasses" @click="_toggle">
        <span :class="innerClasses">
            <slot name="open" v-if="currentValue"></slot>
            <slot name="close" v-if="!currentValue"></slot>
        </span>
    </span>
</template>
<script>
  import Emitter from '../../mixins/emitter'
  const PREFIX_CLASS = 'switch'
  export default {
    name: 'TSwitch',
    mixins: [ Emitter ],
    props: {
      value: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
      size: {
        validator (value) {
          return [ 'lg', 'sm' ].includes(value)
        }
      },
      rounded: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        currentValue: this.value
      }
    },
    computed: {
      wrapClasses () {
        return [
          `${PREFIX_CLASS}`,
          {
            [`${PREFIX_CLASS}--checked`]: this.currentValue,
            [`${PREFIX_CLASS}--disabled`]: this.disabled,
            [`${PREFIX_CLASS}--${this.size}`]: !!this.size,
            [`${PREFIX_CLASS}--round`]: this.rounded
          }
        ]
      },
      innerClasses () {
        return [ `${PREFIX_CLASS}__inner` ]
      }
    },
    methods: {
      _toggle () {
        if (this.disabled) {
          return false
        }
        const checked = !this.currentValue
        this.currentValue = checked
        this.$emit('input', checked)
        this.$emit('on-change', checked)
        this.dispatch('TFormItem', 'on-form-change', checked)
      }
    },
    watch: {
      value (val) {
        this.currentValue = val
      }
    }
  }
</script>



// WEBPACK FOOTER //
// switch.vue?1fcba81e